import {
  Component,
  OnInit,
  signal,
  WritableSignal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ObtenerNumeroAgentesSqlService } from '../../../../application/administrador/services/obtener-numero-agentes-sql.service';
import { ObtenerNumeroFuenteDatosService } from '../../../../application/administrador/services/obtener-numero-fuente-datos.service';
import { ObtenerNumeroColeccionesService } from '../../../../application/administrador/services/obtener-numero-colecciones.service';
import { Observable, zip } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ObtenerNumeroAgentesExtraccionService } from '../../../../application/administrador/services/obtener-numero-agentes-extraccion.service';

@Component({
  selector: 'app-gestion-rag-resumen',
  templateUrl: './gestion-rag-resumen.component.html',
  styleUrl: './gestion-rag-resumen.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GestionRagResumenComponent implements OnInit {
  public numeroAgentesSql: WritableSignal<number> = signal(0);
  public numeroFuenteDatos: WritableSignal<number> = signal(0);
  public numeroColecciones: WritableSignal<number> = signal(0);
  public numeroAgentes: WritableSignal<number> = signal(0);
  public cargando: WritableSignal<boolean> = signal(true);

  constructor(
    private readonly obtenerNumeroAgentesSqlService: ObtenerNumeroAgentesSqlService,
    private readonly obtenerNumeroFuenteDatosService: ObtenerNumeroFuenteDatosService,
    private readonly obtenerNumeroColeccionesService: ObtenerNumeroColeccionesService,
    private readonly obtenerNumeroAgentesExtraccionService: ObtenerNumeroAgentesExtraccionService,
    private toastrService: ToastrService,
  ) {}

  ngOnInit() {
    zip(
      this.obtenerNumeroAgentesSql(),
      this.obtenerNumeroFuenteDatos(),
      this.obtenerNumeroColecciones(),
      this.obtenerNumeroAgentesExtraccion(),
    ).subscribe({
      next: ([usuarios, grupos, perfiles, agentes]) => {
        this.numeroAgentesSql.set(usuarios);
        this.numeroFuenteDatos.set(grupos);
        this.numeroColecciones.set(perfiles);
        this.numeroAgentes.set(agentes);
      },
      error: () => {
        this.toastrService.error(
          'Error al cargar el resumen de gestión RAG',
        );
        this.cargando.set(false);
      },
      complete: () => {
        this.cargando.set(false);
      },
    });
  }
  public obtenerNumeroAgentesSql(): Observable<number> {
    return this.obtenerNumeroAgentesSqlService.__invoke();
  }

  public obtenerNumeroFuenteDatos(): Observable<number> {
    return this.obtenerNumeroFuenteDatosService.__invoke();
  }

  public obtenerNumeroColecciones(): Observable<number> {
    return this.obtenerNumeroColeccionesService.__invoke();
  }

  public obtenerNumeroAgentesExtraccion(): Observable<number> {
    return this.obtenerNumeroAgentesExtraccionService.__invoke();
  }
}
